import axios, { CancelTokenSource } from 'axios';
import Input from 'components/final-form/Input';
import Select from 'components/final-form/Select';
import FormButtonsRow from 'components/layout/FormButtonsRow';
import PraxStyledSegment from 'components/layout/PraxStyledSegment';
import PxGrid from 'components/layout/PxGrid';
import SearchByButtonsStyle from 'components/layout/SearchByButtonsStyle';
import VirtualizedTable from 'components/layout/VirtualizedTable';
import LoaderComponent from 'components/LoaderComponent';
import SearchResultComponent from 'components/SearchResultComponent';
import { TariffConsumerRenderProps, withTariffContext } from 'components/tariffs/TariffContext';
import { NotificationSystemProps, withNotificationSystemContext } from 'context/NotificationSysemContext';
import React, { Component } from "react";
import { Field, Form as FinalForm, FormRenderProps, FormSpy } from 'react-final-form';
import { MessageSourceProps, withMessages } from 'react-message-source';
import { Button, Grid, Header } from 'semantic-ui-react';
import {
  getAllSelectedProceduresByTariffId,
  searchProcedure,
  updateProcedureSelection
} from 'services/procedureServices';
import { getAllTariffs } from 'services/tariffServices';
import styled from 'styled-components';
import { debounce } from 'ts-debounce';
import { ProcedureDto, ProcedureSearchRequest, TariffDto } from 'ts-types/api.types';
import { noop } from 'utils/functionUtils';

const StyledTableRow = styled.div`

  &.ReactVirtualized__Table__row.evenRow:hover {
    background-color: #fff !important;
  }

  &.ReactVirtualized__Table__row.oddRow:hover {
    background-color: #fafafa !important;
  }

  &.ReactVirtualized__Table__row.oddRow:hover,
  &.ReactVirtualized__Table__row.evenRow:hover {
    color: rgb(198, 198, 203) !important;
  }

`;

const TitlesDivider = styled.div`
  margin-bottom: 1rem;
`;

const StyledGrid = styled(Grid)`
  flex: 1 0 200px;
`;

interface Props extends MessageSourceProps, TariffConsumerRenderProps, NotificationSystemProps {
}

interface State {
  foundProcedures: Array<ProcedureDto>,
  selectedProcedures: Array<ProcedureDto>,
  selectedProceduresSet: Set<number>,
  proceduresLoaded: boolean,
  selectedProceduresLoaded: boolean,
  tariffsLoaded: boolean,
  tariffs?: Array<TariffDto>,
  selectedTariffId?: number | undefined,
  searchBy: string,
  scrollToIndex?: number,
  selectionIndex?: number,
  selectionRow?: ProcedureDto,
  cancelTokenSource: CancelTokenSource
}

class ProcedureSelectionView extends Component<Props, State> {

  private mounted: boolean = false;

  constructor(props: Props) {
    super(props);

    const cancelTokenSource = axios.CancelToken.source();

    this.state = {
      foundProcedures: [],
      selectedProcedures: [],
      selectedProceduresSet: new Set(),
      proceduresLoaded: false,
      selectedProceduresLoaded: false,
      tariffsLoaded: false,
      tariffs: [],
      selectedTariffId: undefined,
      searchBy: "code",
      scrollToIndex: 0,
      selectionIndex: 0,
      cancelTokenSource
    };

    const onFinally = () => {
      this.setState({
        tariffsLoaded: true
      })
    };

    getAllTariffs(cancelTokenSource)
        .then(response => {
          const tariffId = response[0].lnkTrfId != null ? response[0].lnkTrfId : response[0].id;
          this.setState({
            tariffs: response,
            selectedTariffId: tariffId
          })
        })
        .catch(noop)
        .finally(onFinally);
  }

  componentDidMount(): void {
    this.mounted = true;
  }

  componentDidUpdate(prevProps: Readonly<Props>, prevState: Readonly<State>, snapshot?: any): void {

    const {cancelTokenSource, selectedTariffId, tariffs} = this.state;

    const onFinally = () => {
      this.setState({
        selectedProceduresLoaded: true
      })
    };

    if (selectedTariffId && prevState.selectedTariffId !== selectedTariffId) {

      // let tariffId = selectedTariffId;

      // const tariff = tariffs!.find(value => value.id === selectedTariffId);

      // if (tariff && tariff.lnkTrfId !== null) {
      //   tariffId = tariff.lnkTrfId;
      // }

      getAllSelectedProceduresByTariffId(selectedTariffId, cancelTokenSource)
          .then((response: any) => {

            const selectedProceduresSet: Set<number> = new Set(response
                .filter(this.findSelectedProcedures)
                .map((proc: ProcedureDto) => proc.id));

            this.setState({
              selectedProcedures: response,
              selectedProceduresSet: selectedProceduresSet
            })
          })
          .catch(noop)
          .finally(onFinally);
    }

  }

  componentWillUpdate(nextProps: Readonly<Props>, nextState: Readonly<State>, nextContext: any): void {

    const {selectedTariffId} = this.state;

    if (nextState.selectedTariffId !== selectedTariffId) {
      this.setState({
        selectedProceduresLoaded: false
      })
    }
  }

  componentWillUnmount(): void {
    this.mounted = false;

    const {cancelTokenSource} = this.state;
    cancelTokenSource && cancelTokenSource.cancel('Operation canceled by user');
  }

  sortByDescription = (proc1: ProcedureDto, proc2: ProcedureDto) => {

    if (proc1.description < proc2.description) {
      return -1;
    }

    if (proc1.description > proc2.description) {
      return 1;
    }

    return 0;

  };

  getEffectiveTariffId = (selectedTariffId: number): number => {

    const {tariffs} = this.state;

    let tariffId = selectedTariffId;

    if (tariffs != null) {
      const selectedTariff = tariffs!.find(value => value.id == selectedTariffId);
      if (selectedTariff!.lnkTrfId != null) {
        tariffId = selectedTariff!.lnkTrfId;
      }
    }

    return tariffId;

  };

  searchByCriteria = (criteria: string, values: Partial<ProcedureSearchRequest>) => {

    this.setState({
      searchBy: criteria
    })

    this.handleSearchCriteriaChange(values);
  };

  handleSubmit = (event: any) => {
    event.preventDefault();
    const {selectionNotificationSystem, getMessage} = this.props;
    const {cancelTokenSource, selectedProceduresSet, selectedTariffId} = this.state;

    //@ts-ignore
    const selectedProcedures: Array<number> = [...selectedProceduresSet];

    if (selectedTariffId) {

      const tariffId = this.getEffectiveTariffId(selectedTariffId);

      updateProcedureSelection(selectedProcedures, tariffId, cancelTokenSource)
          .then(() => {

            // @ts-ignore
            const notification = selectionNotificationSystem.current;
            if (notification) {
              notification.addNotification({
                title: getMessage("medicament.update.success"),
                message: getMessage("medicament.successful.selection"),
                level: 'success'
              });
            }
          }).catch(noop)
    }

  };

  findSelectedProcedures = (procedure: ProcedureDto) => {

    return procedure.selection;
  };

  handleSearchCriteriaChange = debounce((values: Partial<ProcedureSearchRequest>): void => {
    if (!this.mounted) {
      return;
    }

    const valuesCopy = {...values};

    const {cancelTokenSource, searchBy, tariffs} = this.state;

    let tariffId: number | undefined = undefined;

    const tariff = tariffs!.find(value => value.id === valuesCopy.tariffId);
    if (tariff != null) {

      tariffId = tariff!.id;

      // if (tariff!.lnkTrfId != null) {
      //   valuesCopy.tariffId = tariff!.lnkTrfId;
      // }
    }

    this.setState({
      proceduresLoaded: false
    });

    let searchRequest: Partial<ProcedureSearchRequest> = {
      tariffId: valuesCopy.tariffId,
      searchInLinkedTariff: false,
      description: undefined,
      code: undefined
    }

    if (searchBy === "code") {
      if (valuesCopy.code === undefined) {
        valuesCopy.code = "";
      }
      searchRequest.code = valuesCopy.code;
    } else {
      if (valuesCopy.description === undefined) {
        valuesCopy.description = "";
      }
      searchRequest.description = valuesCopy.description;
    }

    const onFinally = () => {
      this.setState({
        proceduresLoaded: true
      })
    };

    searchProcedure(searchRequest, cancelTokenSource)
        .then(response => {

          this.setState({
            foundProcedures: response,
            selectedTariffId: tariffId,
            scrollToIndex: undefined
          });
        })
        .catch(noop)
        .finally(onFinally);
  }, 300);

  render(): React.ReactNode {
    const {proceduresLoaded, selectedProceduresLoaded, tariffsLoaded, selectedProcedures, foundProcedures} = this.state;
    const {getMessage} = this.props;

    const numSelected = selectedProcedures.length;
    const numResults = foundProcedures.length;

    return (
        <PraxStyledSegment>
          <div>
            {tariffsLoaded && this.renderSearchProcedureSegment()}
          </div>
          <TitlesDivider>
            <StyledGrid>
              <Grid.Column width={16}>
              </Grid.Column>
            </StyledGrid>
            <StyledGrid>
              <Grid.Column width={8}>
                <Header size="small" width={8}>
                  <SearchResultComponent numResults={numResults} textMessage={"search.resultsSummary"}/>
                </Header>
              </Grid.Column>
              <Grid.Column width={8} verticalAlign="middle">
                <Header size="small" width={8}>
                  <SearchResultComponent numSelected={numSelected} textMessage={"header.navigation.proceduresSelected"}/>
                </Header>
              </Grid.Column>
            </StyledGrid>
          </TitlesDivider>
          <StyledGrid>
            <Grid.Row>
              <Grid.Column width={8}>
                {!proceduresLoaded
                    ? <LoaderComponent message={getMessage("procedure.loading")}/>
                    : this.renderProceduresSegment()}
              </Grid.Column>
              <Grid.Column width={8}>
                {!selectedProceduresLoaded
                    ? <LoaderComponent message={getMessage("procedure.loading")}/>
                    : this.renderSelectedProcedures()}
              </Grid.Column>
            </Grid.Row>
          </StyledGrid>
          <FormButtonsRow>
            <Button compact type="submit" onClick={this.handleSubmit} primary>{getMessage("button.save")}</Button>
          </FormButtonsRow>
        </PraxStyledSegment>
    );
  }

  renderSearchProcedureSegment = (): JSX.Element => {
    const {tariffs} = this.state;
    return (
        <FinalForm
            onSubmit={() => {
            }}
            initialValues={{
              tariffId: tariffs![0].id
            }}
            subscription={{pristine: true, values: true}}
            render={this.renderSearchForm}
        />
    );
  };

  renderSearchForm = ({values}: FormRenderProps): React.ReactNode => {
    const {getMessage} = this.props;

    const {tariffs, searchBy, foundProcedures} = this.state;
    const tariffOptions = tariffs!.map(tariff => {

      return {
        key: (tariff.id),
        text: tariff.description,
        value: tariff.id
      }
    });

    return (
        <PxGrid>
          <Grid.Row>
            <Grid.Column width={3} verticalAlign="middle">
              {getMessage("tariff")}:
            </Grid.Column>
            <Grid.Column width={4}>
              <Field
                  name="tariffId"
                  component={Select}
                  fluid
                  options={tariffOptions}
              />
            </Grid.Column>
          </Grid.Row>
          <Grid.Row>
            <Grid.Column width={3} verticalAlign="middle">
              {getMessage(`${searchBy}`)}:
            </Grid.Column>
            <Grid.Column width={searchBy === "code" ? 2 : 13}>
              <Field
                  name={searchBy}
                  component={Input}
                  fluid
                  autoFocus
              />
            </Grid.Column>
          </Grid.Row>
          <Grid.Row>
            <Grid.Column width={3} verticalAlign="middle">
              {getMessage("medicament.search.by")}:
            </Grid.Column>
            <Grid.Column width={6}>
              <SearchByButtonsStyle compact size="tiny">
                <Button primary={searchBy === 'code' && true}
                        basic={searchBy === 'code' ? undefined : true}
                        onClick={() => this.searchByCriteria("code", values)}
                >
                  {getMessage("code")}
                </Button>
                <Button primary={searchBy === 'description' && true}
                        basic={searchBy === 'description' ? undefined : true}
                        onClick={() => this.searchByCriteria("description", values)}
                >
                  {getMessage("description")}
                </Button>
              </SearchByButtonsStyle>
            </Grid.Column>
          </Grid.Row>
          <FormSpy subscription={{values: true}}
                   onChange={formState => this.handleSearchCriteriaChange(formState.values)}/>
        </PxGrid>
    )
  };

  selectProcedure = (index: number) => {
    const {foundProcedures, selectedProcedures, selectedProceduresSet} = this.state;

    const selected =
        selectedProcedures
            .find(procedure => procedure.id === foundProcedures[index].id);

    if (!selected) {
      this.setState((prevState: Readonly<State>) => {

            selectedProceduresSet.add(foundProcedures[index].id);
            foundProcedures[index].selection = true;
            const sortSelected = [...prevState.selectedProcedures, foundProcedures[index]];
            sortSelected.sort(this.sortByDescription);
            const selectionIndex = sortSelected.findIndex(proc => proc.id === foundProcedures[index].id);

            return {
              foundProcedures: foundProcedures,
              selectedProcedures: sortSelected,
              selectedProceduresSet: selectedProceduresSet,
              scrollToIndex: undefined,
              selectionRow: foundProcedures[index],
              selectionIndex: selectionIndex
            }
          }
      );
    }
  };

  foundProceduresRowGetter = ({index}: any) => {
    const {foundProcedures} = this.state;

    return foundProcedures[index];
  };

  foundProceduresRowRenderer = ({className, columns, index, key, style}: any) => {
    const a11yProps = {'aria-rowindex': index + 1};

    const {foundProcedures, scrollToIndex} = this.state;

    if (foundProcedures[index].selection) {
      style.color = '#c6c6cb';
      return (
          <StyledTableRow
              {...a11yProps}
              className={className}
              key={key}
              role="row"
              style={style}
              onDoubleClick={() => this.selectProcedure(index)}
          >
            {columns}
          </StyledTableRow>
      );

    }

    if (scrollToIndex === index) {
      style.background = "#b7b7b7";
    }

    return (
        <div
            {...a11yProps}
            className={className}
            key={key}
            role="row"
            style={style}
            onDoubleClick={() => this.selectProcedure(index)}
        >
          {columns}
        </div>
    );
  };


  renderProceduresSegment = (): JSX.Element => {

    const {getMessage} = this.props;
    const {foundProcedures, scrollToIndex} = this.state;

    return (
        <VirtualizedTable
            rowCount={foundProcedures.length}
            rowGetter={this.foundProceduresRowGetter}
            rowRenderer={this.foundProceduresRowRenderer}
            scrollToIndex={scrollToIndex}
            rowHeight={42}
            columns={[
              {
                width: 200,
                label: "Code",
                dataKey: "code"
              },
              {
                width: 800,
                label: (getMessage("description")),
                dataKey: "description"
              }
            ]}
        />
    );
  };


  removeSelectedProcedure = (index: any) => {
    const {selectedProcedures, selectedProceduresSet, foundProcedures} = this.state;

    let modifiedSelectedProcedure = {...selectedProcedures[index]};
    modifiedSelectedProcedure.selection = false;

    const procedureId = modifiedSelectedProcedure.id;

    const procedureExists = foundProcedures.some(procedure => procedure.id === procedureId);

    const scrollToIndex = procedureExists
        ? foundProcedures.findIndex(procedure => procedure.id === procedureId)
        : foundProcedures.length;

    selectedProceduresSet.delete(procedureId);

    if (!procedureExists) {
      foundProcedures.push(modifiedSelectedProcedure);
    }

    foundProcedures[scrollToIndex].selection = false;
    selectedProcedures.splice(index, 1);

    this.setState(() => ({
      foundProcedures: foundProcedures,
      selectedProcedures: selectedProcedures,
      selectedProceduresSet: selectedProceduresSet,
      scrollToIndex: scrollToIndex,
      selectionRow: undefined
    }));

  };

  selectedProceduresRowRenderer = ({className, columns, index, key, style}: any) => {

    const a11yProps = {'aria-rowindex': index + 1};
    const {selectedProcedures, selectionRow} = this.state;

    if (selectionRow !== undefined && selectionRow === selectedProcedures[index]) {
      style.background = "#b7b7b7";
    }

    return (
        <div
            {...a11yProps}
            className={className}
            key={key}
            role="row"
            style={style}
            onDoubleClick={() => this.removeSelectedProcedure(index)}
        >
          {columns}
        </div>
    );
  };

  renderSelectedProcedures = (): JSX.Element => {

    const {getMessage} = this.props;
    const {selectedProcedures, selectionIndex} = this.state;

    return (
        <VirtualizedTable
            rowCount={selectedProcedures.length}
            rowGetter={({index}: any) => selectedProcedures[index]}
            rowRenderer={this.selectedProceduresRowRenderer}
            scrollToIndex={selectionIndex}
            rowHeight={42}
            columns={[
              {
                width: 200,
                label: "Code",
                dataKey: "code"
              },
              {
                width: 800,
                label: (getMessage("description")),
                dataKey: "description"
              }
            ]}
        />
    );
  };
}

const ProcedureSelectionViewWrapper =
    withMessages(
        withTariffContext(
            withNotificationSystemContext(
                ProcedureSelectionView)));

export default ProcedureSelectionViewWrapper;
